import React from 'react'
import { Result } from 'antd';
import NewBotButton from '../newBotButton/NewBotButton';
import { RobotOutlined } from '@ant-design/icons';
type EmptyBannerProps = {}

export const EmptyBanner: React.FunctionComponent<EmptyBannerProps> = props => {
    return <Result
        icon={<RobotOutlined />}
        title="Vous n'avez actuellement aucun agent conversationnel"
        subTitle="Ne perdez pas de temps et créez votre agent conversationnel en quelques clic !"
        extra={<NewBotButton />}
    />
}

export default EmptyBanner
